// extracted by mini-css-extract-plugin
export var quantityInput = "_nj-0";